import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPractice } from "../../../modules/auth/types/auth.types";
import { areArraysEqual } from "../../../utils/helpers";
import { getClientSession } from "../../../utils/clientSessionStore";

export interface PracticeState {
    practice: IPractice | null;
}

interface ChangePracticeProps {
    practice: IPractice | null;
}

const { practice: initialPractice } = getClientSession();

const initialState: PracticeState = {
    practice: initialPractice,
};

export const practiceSlice = createSlice({
    name: "userPractice",
    initialState,
    reducers: {
        handleClearPractice: (state) => {
            state.practice = null;
        },
        handleChangePractice: (
            state,
            action: PayloadAction<ChangePracticeProps>
        ) => {
            const { practice } = action.payload;
            if (practice) {
                if (
                    state.practice?.practice_id === practice.practice_id &&
                    state.practice?.client_id === practice.client_id &&
                    areArraysEqual(state.practice?.roles, practice.roles)
                ) {
                    return;
                }
                state.practice = practice;
            } else {
                state.practice = practice;
            }
        },
    },
});

export const { handleClearPractice, handleChangePractice } =
    practiceSlice.actions;

export default practiceSlice.reducer;
